<template>
	<div class="input-date-selects">
		<select v-model="day" class="day">
			<option disabled value="">{{ $t('labels.general.day') }}</option>
			<option v-for="day in days" :key="day" :value="day">{{ day }}</option>
		</select>
		<select v-model="month" class="month">
			<option disabled value="">{{ $t('labels.general.month') }}</option>
			<option v-for="(month, index) in months" :key="index + 1" :value="pad(index + 1)">{{ month }}</option>
		</select>
		<select v-model="year" class="year">
			<option disabled value="">{{ $t('labels.general.year') }}</option>
			<option v-for="year in years" :key="year" :value="year">{{ year }}</option>
		</select>
	</div>
</template>

<script>
export default {
	$_veeValidate: {
		value () {
			return this.$el.value
		},
		name () {
			return this.name
		}
	},
	props: {
		name: String,
		value: {
			type: null,
			default: null
		}
	},
	data () {
		return {
			day: '',
			month: '',
			year: '',
			localeTracker: 0
		}
	},
	computed: {
		days () {
			const daysInMonth = this.$moment(`${this.year}-${this.month}`, 'YYYY-MM').daysInMonth()
			const days = []
			for (let i = 1; i <= daysInMonth; i++) {
				days.push(this.pad(i))
			}
			return days
		},
		months () {
			const temp = this.localeTracker
			return this.$moment.months()
		},
		years () {
			const currentYear = this.$moment().year()
			const offset = 5
			const years = []
			for (let i = 0; i < 100; i++) {
				years.push(currentYear + offset - i)
			}
			return years
		}
	},
	watch: {
		value: {
			handler (value) {
				const date = this.$moment(value, 'YYYY-MM-DD')
				if (date.isValid()) {
					this.day = date.format('DD')
					this.month = date.format('MM')
					this.year = date.format('YYYY')
				}
			},
			immediate: true
		},
		day () {
			this.setValue()
		},
		month () {
			this.setValue()
		},
		year () {
			this.setValue()
		},
		'$i18n.locale' () {
			this.localeTracker++
		}
	},
	methods: {
		setValue () {
			const dateString = `${this.year}-${this.month.toString().padStart(2, 0)}-${this.day.toString().padStart(2, 0)}`
			const date = this.$moment(dateString, 'YYYY-MM-DD', true)
			const value = date.isValid() ? date.format('YYYY-MM-DD') : ''
			this.$emit('input', value)
		},
		pad (value) {
			return value.toString().padStart(2, 0)
		}
	},
	mounted () {
		this.$el.value = this.value
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/extra/InputDateSelects.vue